/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { ReactElement, useContext, useEffect, useState } from 'react'

import { Button, Col, Descriptions, Input, Row } from 'antd'
import { AxiosResponse } from 'axios'
import ID_COMPONENTE from 'config/idComponente'
import { ApplicationContext } from 'Context'
import IHorario, { STATUS_HORARIOS } from 'Models/docas/IHorario'
import WsDocasService from 'Services/WS_DOCAS'
import { ServiceUpdateResponse } from 'Types/ServiceResponse'

interface IProps {
  horarioDetalhes: IHorario
}

const HorarioDetalhes = ({ horarioDetalhes }: IProps): ReactElement => {
  const { applicationContext } = useContext(ApplicationContext)
  const [observacao, setObservacao] = useState<string | undefined>(
    horarioDetalhes.observacaoCandidato,
  )
  const [salvandoObservacao, setSalvandoObservacao] = useState<boolean>(false)

  const salvaObservacao = async () => {
    setSalvandoObservacao(true)

    const response: AxiosResponse<ServiceUpdateResponse> =
      await WsDocasService.candidatos.atualizaObservacao(
        ID_COMPONENTE.DOCAS,
        horarioDetalhes.cdCandidatoAgendamento!,
        observacao,
      )

    if (response.status === 200 && response.data.statusCode === 501) {
      horarioDetalhes.observacaoCandidato = observacao
    }

    window.alert(response.data.message)

    setSalvandoObservacao(false)
  }

  return (
    <Descriptions
      bordered
      column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}
    >
      <Descriptions.Item label={applicationContext.textoDocumentoViagem!}>
        {horarioDetalhes.documento}{' '}
      </Descriptions.Item>
      <Descriptions.Item label="Status de Produção">
        {horarioDetalhes.horarioStatus === STATUS_HORARIOS.APROVADO &&
          'APROVADO'}
        {horarioDetalhes.horarioStatus === STATUS_HORARIOS.RESERVADO &&
          'RESERVADO'}
      </Descriptions.Item>
      <Descriptions.Item label="Placa">
        {horarioDetalhes.placa}{' '}
      </Descriptions.Item>
      <Descriptions.Item label="Motorista">
        {horarioDetalhes.nomeMotorista}{' '}
      </Descriptions.Item>
      <Descriptions.Item label="Peso">
        {horarioDetalhes.peso}{' '}
      </Descriptions.Item>
      <Descriptions.Item label="Observação Transportadora">
        <Row gutter={0}>
          <Col span={20}>
            <Input
              type="text"
              value={observacao}
              onChange={(e) => setObservacao(e.target.value)}
            />
          </Col>

          <Col span={4}>
            <Button
              type="primary"
              loading={salvandoObservacao}
              onClick={salvaObservacao}
              disabled={observacao === horarioDetalhes.observacaoCandidato}
            >
              Salvar
            </Button>
          </Col>
        </Row>
      </Descriptions.Item>
    </Descriptions>
  )
}

export default HorarioDetalhes
